<page-header title="Dashboard" [subtitle]="subtitle"></page-header>

<div
  class="stats-grid"
  [class.has-vouchers]="insights.showVouchers"
  *ngIf="!pageLoading"
>
  <div class="stat-card">
    <div class="digit-container">
      <div class="image-container">
        <div class="metric-icon" [style.background-color]="'#344734'">
          <mat-icon>loyalty</mat-icon>
        </div>
      </div>
      <div class="text-container">
        <p class="digit-subtitle">
          {{ firstContainerValue }}
        </p>
        <p class="digit-title">
          {{ firstContainerLabel }}
        </p>
      </div>
    </div>
  </div>
  <div class="stat-card">
    <div class="digit-container">
      <div class="image-container">
        <div class="metric-icon" [style.background-color]="'#e7d1b5'">
          <mat-icon>people</mat-icon>
        </div>
      </div>
      <div class="text-container">
        <p class="digit-subtitle">{{ insights.customers ?? "-" }}</p>
        <p class="digit-title">Customers</p>
      </div>
    </div>
  </div>
  <div class="stat-card">
    <div class="digit-container">
      <div class="image-container">
        <div class="metric-icon" [style.background-color]="'#f1a638'">
          <mat-icon>card_giftcard</mat-icon>
        </div>
      </div>
      <div class="text-container">
        <p class="digit-subtitle">{{ insights.rewards ?? "-" }}</p>
        <p class="digit-title">Rewards</p>
      </div>
    </div>
  </div>
  <div class="stat-card">
    <div class="digit-container">
      <div class="image-container">
        <div class="metric-icon" [style.background-color]="'#4CAF50'">
          <mat-icon>redeem</mat-icon>
        </div>
      </div>
      <div class="text-container">
        <p class="digit-subtitle">{{ insights.redemptions ?? "-" }}</p>
        <p class="digit-title">Redemptions</p>
      </div>
    </div>
  </div>
  <div class="stat-card" *ngIf="insights.showVouchers">
    <div class="digit-container">
      <div class="image-container">
        <div class="metric-icon" [style.background-color]="'#b2aeff'">
          <mat-icon>receipt</mat-icon>
        </div>
      </div>
      <div class="text-container">
        <p class="digit-subtitle">
          {{
            (insights.vouchers?.totalSold ?? 0)
              | currency : "GBP" : "symbol" : "1.0-0"
          }}
        </p>
        <p class="digit-title">Vouchers Sold</p>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-lg-6">
    <div style="margin-top: 10px" *ngIf="!pageLoading">
      <div
        style="
          background-color: var(--app-container);
          border-radius: 10px 10px 0px 0px;
          padding: 10px;
        "
      >
        <div
          class="activity-header"
          style="
            margin-left: 10px;
            margin-top: 10px;
            margin-bottom: 10px;
            margin-right: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <h3 class="activity-title" style="margin-bottom: 0px">
            Activity Timeline
          </h3>

          <div>
            <app-primary-button
              [title]="selected"
              [disabled]="false"
              [mat-menu-trigger-for]="userMenu"
              [bgColor]="'white'"
              color="var(--app-timber)"
              border="1px solid lightGrey"
              [icon]="'keyboard_arrow_down'"
              [reverse]="true"
            ></app-primary-button>

            <mat-menu #userMenu="matMenu" class="custom-menu">
              <div *ngFor="let item of dateOptions; let i = index">
                <button
                  class="menu-list-item"
                  style="border-radius: 5px"
                  (click)="tapped(item)"
                  mat-menu-item
                >
                  <span
                    class="menu-list-item-label"
                    [style.fontWeight]="selected == item.title ? '600' : '400'"
                    >{{ item.title }}</span
                  >
                </button>
              </div>
            </mat-menu>
          </div>
        </div>
      </div>

      <mat-tab-group
        mat-align-tabs="start"
        mat-stretch-tabs="false"
        disableRipple="true"
        [animationDuration]="0"
        [(selectedIndex)]="selectedIndex"
        (selectedTabChange)="tabChanged($event.index)"
      >
        >
        <mat-tab label="Stamps" *ngIf="insights?.showStamps == true">
          <div class="chart-container">
            <div class="row">
              <div class="col-lg-12">
                <chart
                  [type]="'stamp'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'stamps'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></chart>
              </div>
              <div class="col-lg-12">
                <hourly-chart
                  [type]="'stamp'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'stamps'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></hourly-chart>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Points" *ngIf="insights?.showPoints == true">
          <div class="chart-container">
            <div class="row">
              <div class="col-lg-12">
                <chart
                  [type]="'point'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'points'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></chart>
              </div>
              <div class="col-lg-12">
                <hourly-chart
                  [type]="'point'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'points'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></hourly-chart>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Redemptions">
          <div class="chart-container">
            <div class="row">
              <div class="col-lg-12">
                <chart
                  [type]="'redemption'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'redemptions'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></chart>
              </div>
              <div class="col-lg-12">
                <hourly-chart
                  [type]="'redemption'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'redemptions'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></hourly-chart>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Cards">
          <div class="chart-container">
            <div class="row">
              <div class="col-lg-12">
                <chart
                  [type]="'card'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'cards'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></chart>
              </div>
              <div class="col-lg-12">
                <hourly-chart
                  [type]="'card'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'cards'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></hourly-chart>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Rewards">
          <div class="chart-container">
            <div class="row">
              <div class="col-lg-12">
                <chart
                  [type]="'reward'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'rewards'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></chart>
              </div>
              <div class="col-lg-12">
                <hourly-chart
                  [type]="'reward'"
                  [chartType]="viewType"
                  *ngIf="viewType !== 'hide' && selectedTab === 'rewards'"
                  [days]="days"
                  (optionTapped)="daysSelected($event)"
                ></hourly-chart>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div class="col-lg-3">
    <div style="margin-top: 10px" *ngIf="!pageLoading">
      <div
        *ngIf="hasPromotionsAccess"
        style="
          background-color: var(--app-container);
          border-radius: 10px;
          padding: 10px;
        "
      >
        <div class="chart-container" style="margin-bottom: 0px">
          <div class="activity-header">
            <h3 class="activity-title">Promotions</h3>
          </div>
          <div *ngIf="promotions?.length">
            <div
              style="
                display: flex;
                overflow-x: auto;
                padding-bottom: 10px;
                gap: 10px;
                margin-top: 10px;
              "
            >
              <promotion-card
                *ngFor="let promo of promotions"
                [promo]="promo"
                [promoState]="promo._promoState!"
                [reducedSummary]="true"
              ></promotion-card>
            </div>
          </div>

          <div *ngIf="!promotions?.length" style="text-align: center">
            <app-primary-button
              title="Create a Promotion"
              [disabled]="false"
              (click)="openAutomations()"
              [icon]="'campaign'"
              [bgColor]="'var(--app-timber)'"
              [color]="'white'"
            ></app-primary-button>
          </div>
        </div>
      </div>

      <div
        style="
          background-color: var(--app-container);
          border-radius: 10px;
          padding: 10px;
          margin-top: 20px;
        "
      >
        <div class="chart-container" style="margin-bottom: 0px">
          <div class="activity-header">
            <h3 class="activity-title">Customer Journey</h3>
          </div>
          <funnel-chart [type]="'stamp'" [chartType]="'bar'"></funnel-chart>
        </div>
      </div>

      <div
        style="
          background-color: var(--app-container);
          border-radius: 10px;
          padding: 10px;
          margin-top: 20px;
        "
      >
        <!-- Age Distribution Pie Chart -->
        <div class="chart-container" style="margin-bottom: 0px">
          <div class="activity-header">
            <h3 class="activity-title">Age Distribution</h3>
          </div>
          <pie-chart [type]="'age'" [days]="days"></pie-chart>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-3">
    <div style="margin-top: 10px" *ngIf="!pageLoading">
      <div
        style="
          width: 100%;
          background-color: var(--app-container);
          border-radius: 10px;
          padding: 20px;
        "
      >
        <div class="activity-header">
          <h3 class="activity-title">Recent Activity</h3>
        </div>

        <div style="max-height: calc(80vh - 60px); overflow-y: auto">
          <div
            *ngIf="customerActivity.length === 0"
            style="text-align: center; padding: 20px"
          >
            <p>No recent activity to display</p>
          </div>

          <!-- FOR BELOW INSIDE ACTIVITY ITEM [class.new-activity]="isNewActivity(activity._id)"
            [@fadeInSlide]="isNewActivity(activity._id)" -->

          <div *ngFor="let activity of customerActivity" class="activity-item">
            <div
              class="activity-icon"
              [ngStyle]="{
                'background-color':
                  activity.type === 'stamp'
                    ? '#344734'
                    : activity.type === 'reward'
                      ? '#f1a638'
                      : activity.type === 'redemption'
                        ? '#4CAF50'
                        : activity.type === 'voucher'
                          ? '#b2aeff'
                          : '#e7d1b5',
              }"
            >
              <mat-icon>
                {{
                  activity.type === "voucher"
                    ? "receipt"
                    : activity.type === "stamp"
                      ? "loyalty"
                      : activity.type === "reward"
                        ? "card_giftcard"
                        : activity.type === "redemption"
                          ? "redeem"
                          : "people"
                }}
              </mat-icon>
            </div>

            <div class="activity-content">
              <p class="activity-details">
                <a
                  *ngIf="activity.customer?.nanoid"
                  [routerLink]="['/customer', activity.customer?.nanoid]"
                  (click)="$event.stopPropagation()"
                  style="text-decoration: none; font-weight: bold; color: black"
                >
                  {{ activity.customer?.name }}
                </a>
                <span
                  *ngIf="!activity.customer?.nanoid"
                  style="font-weight: bold; color: black"
                >
                  {{ activity.customer?.name }}
                </span>
                <span style="color: black">{{ " " + activity.details }}</span>
              </p>
              <span class="activity-time">{{
                activity.timestamp | timeAgo
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<loader [loading]="loading || saving"></loader>
